"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceState = void 0;
var PlaceState;
(function (PlaceState) {
    PlaceState["reviewRequired"] = "reviewRequired";
    PlaceState["accepted"] = "accepted";
})(PlaceState || (exports.PlaceState = PlaceState = {}));
//# sourceMappingURL=PlaceStateDto.js.map